import React from 'react';
import styled from 'styled-components';
import AllbinBar from 'allbin-bar';
import ER from 'error-reporting';
import Spinner from '../base/Spinner';
import Navbar from '../base/Navbar';
import * as oh from '../../helpers/output_helpers';
import * as api_helpers from '../../helpers/api_helpers';
import ServiceIconHamta from '../../img/hamta_logo.svg';
import ServiceIconIWA from '../../img/iwa_logo.svg';
import ServiceIconIWATest from '../../img/iwa_test_logo.svg';
import ServiceIconDashboard from '../../img/dashboard_logo.svg';
import ServiceIconSSOAdmin from '../../img/users_logo.svg';
import ServiceIconDefault from '../../img/dashboard_logo.svg';
import ServiceIconRouteRedirection from '../../img/route_redirection_logo.svg';
import ServiceIconMap from '../../img/map_logo.svg';
import ServiceStopAnalysis from '../../img/stop_analysis_logo.svg';
import ServiceSome from '../../img/some_logo.svg';
import ServiceBulletin from '../../img/bulletin_logo.svg';
import ServiceSenseView from '../../img/senseview_logo.svg';
import changelog from '../../changelog';
import withConfig from 'with-config';

class MainView extends React.Component {
  constructor(props) {
    super(props);

    this.Container = styled.div`
      .main_body {
        padding: 40px 30px;
      }
      .fade {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: rgba(62, 62, 62, 0);
        transition: all 0.4s;
        pointer-events: none;
        &.active {
          background-color: rgba(62, 62, 62, 0.3);
          pointer-events: all;
        }
      }
      ul.services {
        width: 100%;
        display: grid;
        grid-template-columns: 32% 32% 32%;
        grid-template-rows: auto;
        grid-column-gap: 2%;
        grid-row-gap: 4%;
        @media only screen and (max-width: 1100px) {
          grid-template-columns: 49% 49%;
          grid-row-gap: 16px;
        }
        @media only screen and (max-width: 800px) {
          grid-template-columns: 100%;
          grid-row-gap: 16px;
        }
        li {
          overflow: hidden;
          width: 100%;
          white-space: nowrap;
          border-radius: 20px;
          border: 1px solid transparent;
          background-color: #fff;
          transition: all 0.4s;
          cursor: pointer;
          box-shadow: 0 4px 6px 0 rgba(133, 138, 140, 0.22);
          &:hover {
            box-shadow: 0 4px 12px 0 rgba(133, 138, 140, 0.4);
            border-color: #3f3f3f4f;
          }
          a {
            display: block;
          }
          .icon,
          .text {
            display: inline-flex;
            height: auto;
            vertical-align: middle;
          }
          .icon {
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            width: 100px;
            height: 100px;
          }

          .text {
            width: calc(100% - 100px);
            padding-right: 12px;
            .contain_text {
              padding-left: 12px;
            }
            .title {
              font-size: 16px;
              margin-bottom: 6px;
              font-weight: bold;
            }
            .subtitle {
              font-size: 14px;
              opacity: 0.7;
              white-space: initial;
            }
          }
        }
      }
    `;

    this.state = {
      me: null,
      user_dropdown_open: false,
      selected_category: 0,
    };
  }

  componentWillMount() {
    api_helpers
      .fetchMyself()
      .then(user => {
        user = this.removeHiddenServices(user);

        this.setState({
          me: user,
          services: this.processUserServices(user),
        });
      })
      .catch(err => {
        err.additional_message = 'Err when fetching myself.';
        ER.setError(err);
      });
  }

  removeHiddenServices(user) {
    this.props.config.services_to_not_show.forEach(service_name => {
      delete user.services[service_name];
    });
    return user;
  }

  processUserServices(user) {
    return Object.keys(user.services)
      .filter(service_name =>
        window.sso.specs.service_defs.hasOwnProperty(service_name),
      )
      .map(service_name => {
        return {
          icon: window.sso.specs.service_defs[service_name].icon,
          name: service_name,
          url: window.sso.specs.service_defs[service_name].url,
        };
      });
  }

  getIconForService(service) {
    switch (service.icon) {
      case 'hamta':
        return ServiceIconHamta;
      case 'dashboard':
        return ServiceIconDashboard;
      case 'sso':
        return ServiceIconSSOAdmin;
      case 'iwa':
        return ServiceIconIWA;
      case 'iwa_test':
        return ServiceIconIWATest;
      case 'redirect':
        return ServiceIconRouteRedirection;
      case 'map':
        return ServiceIconMap;
      case 'stop_analysis':
        return ServiceStopAnalysis;
      case 'some':
        return ServiceSome;
      case 'bulletin':
        return ServiceBulletin;
      case 'senseview':
        return ServiceSenseView;
      default:
        return ServiceIconDefault;
    }
  }

  logout() {
    if (window.hasOwnProperty('sso')) {
      window.sso.logout();
    }
  }

  render() {
    // let a = { b: "b" };
    // let b = a.c.b;
    // console.log(b);

    if (this.state.me === null) {
      return (
        <this.Container>
          <Spinner text={oh.translate('loading')} />
        </this.Container>
      );
    }

    this.order_state_categories = [
      {
        name: oh.translate('your_services'),
        onClick: () => {
          this.setState({
            selected_category: 0,
          });
        },
      },
    ];

    return (
      <this.Container>
        <AllbinBar
          language={window.sso.getJWT().getClaim('lang')}
          background={'#2B344D'}
          navbar={true}
          styled_service_name={true}
          logout={true}
          service_name={oh.translate('dashboard')}
          enable_password_reset={false}
          dashboard_link={true}
          contact={true}
          changelog={changelog}
          help={false}
          show_credentials={true}
        />
        <Navbar
          border
          categories={this.order_state_categories}
          selected_category={this.state.selected_category}
        />
        <div
          className={`fade ${this.state.user_dropdown_open ? 'active' : null}`}
          onClick={() => this.setState({user_dropdown_open: false})}></div>
        <div className="main_body">
          <ul className="services">
            {this.state.services.map(service => {
              return (
                <li key={service.name}>
                  <a href={service.url}>
                    <div
                      className={`icon`}
                      style={{
                        backgroundImage:
                          'url(' + this.getIconForService(service) + ')',
                      }}></div>
                    <div className="text">
                      <div className="contain_text">
                        <p className="title">
                          {oh.translateServiceName(service.name)}
                        </p>
                        <p className="subtitle">
                          {oh.translate(
                            service.name + '_info',
                            true,
                            null,
                            true,
                          )}
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </this.Container>
    );
  }
}

export default withConfig(MainView);



// WEBPACK FOOTER //
// ./src/components/views/MainView.jsx